import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getMIPInvestorsDataForSendModal } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service';
import { useMIPManageContext } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/MIPManageContext.ts';
import { useSendInvestorInvitations } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/hooks/useSendInvestorInvitations.ts';

interface Props {
	investorId: string;
	onClose: () => void;
}

export const useInviteInvestorModal = ({ investorId, onClose }: Props) => {
	const { mipData, hasEditorRole, disableSendInvestorInvitation } = useMIPManageContext();
	const [modalOpened, setModalOpened] = useState(false);
	const { sendInvitations, isSending } = useSendInvestorInvitations();

	const sendModalDataQuery = useQuery({
		queryKey: [
			API_PATHS.MIP_INVESTOR_INVITE_INVESTORS_DATA_POST,
			{ selectedIds: [investorId] },
		],
		queryFn: ({ signal }) =>
			getMIPInvestorsDataForSendModal(
				API_PATHS.MIP_INVESTOR_INVITE_INVESTORS_DATA_POST,
				{ selectedIds: [investorId] },
				signal
			),
		enabled: modalOpened,
	});

	return {
		modalOpened,
		openModal: () => setModalOpened(true),
		closeModal: () => {
			setModalOpened(false);
			onClose();
		},
		investors: sendModalDataQuery.data?.payload?.investors ?? [],
		sendInvitations,
		isLoading: isSending || sendModalDataQuery.isLoading,
		isDisabled: !hasEditorRole || !!mipData?.isLocked || disableSendInvestorInvitation,
	};
};
